import React, { useState } from "react";
import { useEffect } from "react";
import { useAlert } from "react-alert";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import api from "../../api";
import userAction from "../../redux/users/action";
import { Box, Rating, styled } from "@mui/material";
import { CircleSharp, CircleOutlined } from "@mui/icons-material";

const StyledRating = styled(Rating)({
  "& .MuiRating-iconFilled": {
    color: "#ff6d75",
  },
  "& .MuiRating-iconHover": {
    color: "#ff3d47",
  },
});

export const PaidFeedback = ({ SubsData }) => {
  const location = useLocation();
  const { setUser } = userAction;
  const dispatch = useDispatch();

  const userStore = useSelector((state) => state.userReducer);
  const alert = useAlert();
  const [data, setData] = useState({});
  const [loader, setLoader] = useState(false);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [featuresExplored, setFeaturesExplored] = useState([]);
  const [ratingData, setRatingData] = useState({});

  const handleSubmit = async () => {
    try {
      const validatorsResponse = validators();

      if (validatorsResponse) {
        return alert.show(validatorsResponse);
      }

      let payload = {
        satisfaction_level: data.satisfaction_level,
        features_explored: featuresExplored,
        feature_helpfulness: ratingData,
        about_premium_comment: data.about_premium_comment,
        improve_experience: data.improve_experience,
        suggestions: data.suggestions,
        recommend_others: data.recommend_others,
      };
      setLoader(true);

      const response = await api.memberFeedbackAdd(payload);
      // console.log(response);
      if (response?.success) {
        handleClose();
        setLoader(false);
        alert.show("Thanks for your feedback.");
      }
    } catch (error) {
      console.log(error?.message);
      alert.show("Something went wrong");
    }
  };

  const checkSubmitted = async () => {
    try {
      const res = await api.memberFeedbackSubmitted();
      // console.log(res);
      if (res?.success) {
        handleClose();
      } else {
        handleShow();
      }
    } catch (error) {
      console.log(error?.message);
    }
  };

  const validators = () => {
    if (!data?.satisfaction_level) {
      return "Please Select option from point 1";
    }
    if (featuresExplored.length == 0) {
      return "Please select atleast 1 option from point 2";
    }
    if (!ratingData?.Market_Updates) {
      return "Please rate Market Update from point 3";
    }
    if (!ratingData?.Web3_Education) {
      return "Please rate Web3 Education from point 3";
    }
    if (!ratingData?.Crypto_Trade_Signals) {
      return "Please rate Crypto Trade Signals from point 3";
    }
    if (!ratingData?.Stock_and_Commodity) {
      return "Please rate Stock & Commodity from point 3";
    }
    if (!data?.about_premium_comment) {
      return "Please add your feedback in point 4";
    }
    if (!data?.improve_experience) {
      return "Please add your feedback in point 5";
    }
    if (!data?.recommend_others) {
      return "Please select atleast 1 option from point 6";
    }
    if (!data?.suggestions) {
      return "Please add your suggestions";
    }

    return false;
  };

  useEffect(() => {
    if (userStore?.users?.user?._id && SubsData?.createdAt) {
      if (shouldShowModal(SubsData?.createdAt)) {
        checkSubmitted();
      }
    }
  }, [userStore?.users, SubsData]);

  const shouldShowModal = (createdAt) => {
    const now = new Date();
    const subscribedAt = new Date(createdAt);
    const diffInMs = now - subscribedAt;
    const diffInHours = diffInMs / (1000 * 60 * 60);
    return diffInHours > 240; // 10 days
  };

  const onTextChange = (e, type) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setFeaturesExplored((prev) => [...prev, value]);
    } else {
      setFeaturesExplored((prev) => prev.filter((v) => v !== value));
    }
  };

  return (
    <Modal size="xl" show={show} centered className="feedbackModal">
      <Modal.Body>
        <div className="otpModalMain">
          <div className="closeIcon" onClick={handleClose}>
            <i className="fa-solid fa-xmark" />
          </div>
          <h1 className="heading">Premium Member Feedback Form</h1>
          <div className="welcome">
            Welcome to WaqarZaka.net Premium We'd Love Your Feedback!
          </div>
          <div className="tagline">
            Now that you've had 48 hours to explore the content and services,
            let us know how we’re doing. Your feedback helps us improve!
          </div>
          <div className=" mt-4 m-0 p-0 feedbackForm">
            <div className="form-group ">
              <label>
                1. How satisfied are you with your premium experience so far?
              </label>
              <div className="optionRowM">
                <div className="optionRow">
                  <input
                    className="checkbox me-2"
                    type="radio"
                    name="satisfaction_level"
                    value={"Very Satisfied"}
                    onChange={(e) => onTextChange(e)}
                    id=""
                  />
                  <span className="text">&#128512; Very Satisfied</span>
                </div>
                <div className="optionRow">
                  <input
                    className="checkbox me-2"
                    type="radio"
                    name="satisfaction_level"
                    value={"Satisfied"}
                    onChange={(e) => onTextChange(e)}
                    id=""
                  />
                  <span className="text">&#127773; Satisfied</span>
                </div>
                <div className="optionRow">
                  <input
                    className="checkbox me-2"
                    type="radio"
                    name="satisfaction_level"
                    value={"Neutral"}
                    onChange={(e) => onTextChange(e)}
                    id=""
                  />
                  <span className="text">&#128528; Neutral</span>
                </div>
                <div className="optionRow">
                  <input
                    className="checkbox me-2"
                    type="radio"
                    name="satisfaction_level"
                    value={"Unsatisfied"}
                    onChange={(e) => onTextChange(e)}
                    id=""
                  />
                  <span className="text">&#128533; Unsatisfied</span>
                </div>
                <div className="optionRow">
                  <input
                    className="checkbox me-2"
                    type="radio"
                    name="satisfaction_level"
                    value={"Very Unsatisfied"}
                    onChange={(e) => onTextChange(e)}
                    id=""
                  />
                  <span className="text">&#128545; Very Unsatisfied</span>
                </div>
              </div>
            </div>
            <div className="form-group">
              <label>
                2. Which premium feature(S) have you explored so far? (Select
                all that apply){" "}
              </label>
              <div className="optionRowM">
                <div className="optionRow">
                  <input
                    className="checkbox me-3"
                    type="checkbox"
                    onChange={handleCheckboxChange}
                    value={"Daily Market Updates"}
                    name=""
                    id=""
                  />
                  <span className="text"> Daily Market Updates</span>
                </div>
                <div className="optionRow">
                  <input
                    className="checkbox me-3"
                    type="checkbox"
                    value={"Web3 Education"}
                    onChange={handleCheckboxChange}
                    name=""
                    id=""
                  />
                  <span className="text"> Web3 Education</span>
                </div>
                <div className="optionRow">
                  <input
                    className="checkbox me-3"
                    type="checkbox"
                    value={"Crypto Trading Calls"}
                    onChange={handleCheckboxChange}
                    name=""
                    id=""
                  />
                  <span className="text">Crypto Trading Calls</span>
                </div>
                <div className="optionRow">
                  <input
                    className="checkbox me-3"
                    type="checkbox"
                    value={"Stock & Commodity Trading Calls"}
                    onChange={handleCheckboxChange}
                    name=""
                    id=""
                  />
                  <span className="text">Stock & Commodity Trading Calls</span>
                </div>
                <div className="optionRow">
                  <input
                    className="checkbox me-3"
                    type="checkbox"
                    value={"Live Community/Telegram Access"}
                    onChange={handleCheckboxChange}
                    name=""
                    id=""
                  />
                  <span className="text">Live Community/Telegram Access</span>
                </div>
                <div className="optionRow">
                  <input
                    className="checkbox me-3"
                    type="checkbox"
                    value={"None yet"}
                    onChange={handleCheckboxChange}
                    name=""
                    id=""
                  />
                  <span className="text">None yet</span>
                </div>
              </div>
            </div>
            <div className="form-group ratingMain">
              <label>
                3. On a scale of 1 to 5, how helpful are the following features?
              </label>

              <div className="text-right mb-2">
                <small>1 (Not Helpful) 2 3 4 5 (Very Helpful)</small>
              </div>

              <div className="row">
                <div className="col-lg-6">
                  <div className="ratingRow">
                    <span className="text"> Market Updates</span>
                    <div className="ratingM">
                      <CustomizedRating
                        name={"Market_Updates"}
                        setRatingData={setRatingData}
                        ratingData={ratingData}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="ratingRow">
                    <span className="text"> Web3 Education</span>
                    <div className="ratingM">
                      <CustomizedRating
                        name={"Web3_Education"}
                        setRatingData={setRatingData}
                        ratingData={ratingData}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="ratingRow">
                    <span className="text"> Crypto Trade Signals</span>
                    <div className="ratingM">
                      <CustomizedRating
                        name={"Crypto_Trade_Signals"}
                        setRatingData={setRatingData}
                        ratingData={ratingData}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="ratingRow">
                    <span className="text"> Stock & Commodity Trade Calls</span>
                    <div className="ratingM">
                      <CustomizedRating
                        name={"Stock_and_Commodity"}
                        setRatingData={setRatingData}
                        ratingData={ratingData}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="form-group">
              <label>4. What do you like most about your premium access?</label>
              <textarea
                placeholder="Your Feedback"
                className="form-control"
                name="about_premium_comment"
                id=""
                onChange={(e) => onTextChange(e)}
                rows={3}
              ></textarea>
            </div>
            <div className="form-group">
              <label>5. How can we improve your experience?</label>
              <textarea
                placeholder="Your Feedback"
                className="form-control"
                name="improve_experience"
                id=""
                onChange={(e) => onTextChange(e)}
                rows={3}
              ></textarea>
            </div>
            <div className="form-group">
              <label>6. Would you recommend WaqarZaka.net to others?</label>
              <div className="optionRowM">
                <div className="optionRow">
                  <input
                    className="checkbox me-3"
                    type="radio"
                    name="recommend_others"
                    value={"Yes, absolutely"}
                    id=""
                    onChange={(e) => onTextChange(e)}
                  />
                  <span className="text">Yes, absolutely</span>
                </div>
                <div className="optionRow">
                  <input
                    className="checkbox me-3"
                    type="radio"
                    name="recommend_others"
                    value={"Maybe — if some things improve"}
                    onChange={(e) => onTextChange(e)}
                  />
                  <span className="text">Maybe — if some things improve</span>
                </div>
                <div className="optionRow">
                  <input
                    className="checkbox me-3"
                    type="radio"
                    name="recommend_others"
                    value={"No, not yet"}
                    onChange={(e) => onTextChange(e)}
                    id=""
                  />
                  <span className="text">No, not yet</span>
                </div>
              </div>
            </div>
            <div className="form-group">
              <label>
                {" "}
                Any other suggestions, comments, or feature requests?
              </label>
              <textarea
                placeholder="Your Feedback"
                className="form-control"
                name="suggestions"
                id=""
                onChange={(e) => onTextChange(e)}
                rows={3}
              ></textarea>
            </div>
          </div>
          <div className="mt-4">
            <button className="themeBlackBtn" onClick={handleSubmit}>
              Submit Feedback
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default function CustomizedRating({ setRatingData, ratingData, name }) {
  const handleChange = (e, val) => {
    setRatingData({ ...ratingData, [e.target.name]: val });
  };
  return (
    <Box sx={{ "& > legend": { mt: 2 } }}>
      <StyledRating
        name={name}
        defaultValue={0}
        getLabelText={(value) => `${value} Heart${value !== 1 ? "s" : ""}`}
        onChange={(event, value) => handleChange(event, value)}
        precision={1}
        icon={<CircleSharp fontSize="inherit" />}
        emptyIcon={<CircleOutlined fontSize="inherit" />}
      />
    </Box>
  );
}
